/**
 * Metrics — building blocks for dashboards (email dashboard, admin, WhatsApp …).
 *
 *   <StatCard title="תור עבודות" extra={…}>…</StatCard>   white card with a title row
 *   <Metric value={12} label="ממתינות" color="#16A34A" size="lg" />
 *                                                         big (lg) or small (sm, default) number + label
 *   <MetricRow>{Metric × n}</MetricRow>                   evenly spaced row of small metrics
 *   <Meter label="דקה" value={3} max={14} warnAt={0.8} /> "3 / 14" + bar (green → amber at warnAt
 *                                                         → red when full)
 *   <StatusDot color="#16A34A">מתזמן פעיל</StatusDot>     colored dot + text (service states)
 */
import React from 'react';
import styles from './Metrics.css';

export const StatCard = ({ title, extra, children, className }) => (
  <section className={[styles.card, className].filter(Boolean).join(' ')}>
    {title || extra ? (
      <div className={styles.cardHead}>
        <h3 className={styles.cardTitle}>{title}</h3>
        {extra ? <div className={styles.cardExtra}>{extra}</div> : null}
      </div>
    ) : null}
    <div className={styles.cardBody}>{children}</div>
  </section>
);

export const Metric = ({ value, label, color, size = 'sm', hint }) => (
  <div className={size === 'lg' ? styles.metricLg : styles.metric} title={hint}>
    <span className={`${styles.metricValue} ui-tabular`} style={color ? { color } : undefined}>
      {value}
    </span>
    <span className={styles.metricLabel}>{label}</span>
  </div>
);

export const MetricRow = ({ children }) => <div className={styles.metricRow}>{children}</div>;

export const Meter = ({ label, value = 0, max = 1, warnAt = 0.8, color }) => {
  const ratio = max > 0 ? value / max : 0;
  const fill = color || (ratio >= 1 ? '#DC2626' : ratio >= warnAt ? '#D97706' : '#16A34A');
  return (
    <div className={styles.meter}>
      <div className={styles.meterHead}>
        <span>{label}</span>
        <span className="ui-tabular">
          {value} <span className={styles.meterMax}>/ {max}</span>
        </span>
      </div>
      <div className={styles.meterBar}>
        <span className={styles.meterFill} style={{ width: `${Math.min(100, ratio * 100)}%`, background: fill }} />
      </div>
    </div>
  );
};

export const StatusDot = ({ color = '#A1A1AA', children }) => (
  <span className={styles.statusDot}>
    <span className={styles.dot} style={{ background: color }} />
    {children}
  </span>
);
